import React, { useEffect, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import revenueIcon from "./../../../assets/revenue.svg";
import increaseRevenueIcon from "./../../../assets/increase_revenue.svg";
import { NumericFormat } from "react-number-format";
import { calculateIncreasePaymentCollection } from "../../../api/ApiService";
import Card from "../../Card/Card";
import useRoi from "../../../Context/RoiContex";

function PaymentTabContent(props) {
  const {
    numberOfProviders,
    reduceNoShowInputValue,
    monthlyAppointments,
    averageOrderValueEachPatientPerVisitOrPatientTicketSize,
    updatePaymentCollectionData,
    updatePaymentCollectionInputValue,
    paymentCollectionInputValue,
  } = useRoi();
  const [inputValue, setInputValue] = useState(paymentCollectionInputValue);
  const [paymentLocalCollectionData, setPaymentCollectionData] = useState({
    additionalRevenue: 0,
    annualIncrease: 0,
  });

  useEffect(() => {
    const getInitialData = async () => {
      try {
        const param = {
          averageOrderValueEachPatientPerVisitOrPatientTicketSize: parseInt(
            averageOrderValueEachPatientPerVisitOrPatientTicketSize
          ),
          monthlyAppointments: monthlyAppointments,
          percentOfBalanceRemainsUncollectedOrPlacedCollectionAgency: inputValue / 100,
        };
        const response = await calculateIncreasePaymentCollection(param);
        setPaymentCollectionData(response);
        const { additionalRevenue, annualIncrease } = response;
        updatePaymentCollectionData({ additionalRevenue, annualIncrease });
      } catch (error) {
        console.error("Error fetching staff data:", error);
      } finally {
        // setIsLoading(false); // Set loading state to false after successful or failed fetch
      }
    };
    getInitialData();
  }, [
    inputValue,
    reduceNoShowInputValue,
    monthlyAppointments,
    averageOrderValueEachPatientPerVisitOrPatientTicketSize,
  ]);

  const onSliderChange = (value) => {
    setInputValue(value);
    updatePaymentCollectionInputValue(value);
  };
  return (
    <div className="mx-0">
      <div className="w-full">
        <div className="flex justify-between items-center mt-6 boost-patient-payment">
          <label htmlFor="collecton-agency" className="text-lg text-[#1A1A1A] font-semibold">
            Percentage of patient balance that remains uncollected OR is placed with a collection
            agency
          </label>
          <NumericFormat
            name="collecton-agency"
            id="collecton-agency"
            value={inputValue}
            onValueChange={(values) => {
              const { value } = values;
              setInputValue(value);
              updatePaymentCollectionInputValue(value);
            }}
            suffix="%"
            allowNegative={false}
            className="ha-roi-form-input"
          />
        </div>
        <div style={{ position: "relative", top: "12px" }}>
          <Slider
            min={0}
            max={100}
            value={inputValue}
            trackStyle={{ backgroundColor: "#147D6E" }}
            handleStyle={{
              borderColor: "#147D6E",
              backgroundColor: "#147D6E",
            }}
            onChange={onSliderChange}
          />
        </div>
      </div>
      <p className="text-xl font-bold mt-6" style={{ marginTop: "35px" }}>
        By leveraging digital payment channels and automated reminders, you increase your
        collections by:
      </p>
      <div className="flex  gap-5 w-full  my-4 second-second-card">
        <Card
          icon={revenueIcon}
          message="per month"
          value={paymentLocalCollectionData.additionalRevenue}
          color="#71B254"
        />
        <Card
          icon={increaseRevenueIcon}
          message="annually"
          value={paymentLocalCollectionData.annualIncrease}
          color="#147D6E"
        />
      </div>
    </div>
  );
}

export default PaymentTabContent;
